const maxPictureResize = () => {
	const pictures = document.querySelectorAll(
        '.internet-com-max__section__background-pictures'
	);
	const amountOfCards = document.querySelectorAll(
		'.internet-com-max__section__container__main__offer-cards__card'
	);


	
	if (amountOfCards?.length > 1) {
		pictures?.forEach((item) => {
			if (window.innerWidth < 768) {
				item.style.height = '914px';
			} else {
				item.style.height = '568px';
			}
		});
	}
};

window.addEventListener('resize', maxPictureResize);
maxPictureResize();
